import { createSurveyStyles } from '@sm/webassets';
import { WrenchTheme } from '@wds/styles';

type StyleNames = 'progressBarContainer' | 'progressBar' | 'textRight' | 'textLeft';
type StyleProps = {
  isRTL: boolean;
};

const useStyles = createSurveyStyles<StyleNames, StyleProps>(theme => {
  return {
    progressBarContainer: {
      height: 24,
      background: theme.primaryAccentColor ?? {},
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: 'auto',
      width: 300,
      borderRadius: 12,
      direction: ({ isRTL }: StyleProps) => (isRTL ? 'rtl' : null),
    },
    progressBar: {
      width: 200,
      marginLeft: 10,
      marginRight: 10,
    },
    textLeft: {
      fontFamily: WrenchTheme.type.fontFamily.base,
      color: theme.secondaryAccentColor ?? {},
      fontSize: 13,
      margin: ({ isRTL }: StyleProps) => (isRTL ? '0 10px 0 0' : '0 0px 0 10px'),
    },
    textRight: {
      fontFamily: WrenchTheme.type.fontFamily.base,
      color: theme.secondaryAccentColor ?? {},
      fontSize: 13,
      margin: ({ isRTL }: StyleProps) => (isRTL ? '0 0 0 10px' : '0 10px 0 0'),
    },
  };
});

export default useStyles;
